import { render, staticRenderFns } from "./MenuUserDesktop.vue?vue&type=template&id=66b96330&"
import script from "./MenuUserDesktop.vue?vue&type=script&lang=js&"
export * from "./MenuUserDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports